import { Map as ImmutableMap } from 'immutable'
import { actionTypes } from './draftEditor'
import { QuickPickTimes } from '~/reactapp/App/Publish/quickDates'
import { EllipsisReduxStore } from '~/types'

/**
 * IEllipsisReduxStore is an interface, representing entire ellipsis application store type
 * TODO: add types for each reducer as we move towards TS
 */
export interface IEllipsisReduxStore {
  appState: EllipsisReduxStore['appState']
  draftEditor: {
    toolboxSettings: any // eslint-disable-line @typescript-eslint/no-explicit-any
  }
  storyData: {
    isValid: boolean
    validationMsg: string
  }
  settings: {
    quickPickTimes: QuickPickTimes
    timezone: string
    clockFormat: '12' | '24'
    customEmbed: {
      // view, edit, etc. should be URLs
      [subtype: string]: {
        view: string
        edit: string
        search: string
        loadTimeout?: number
        caption?: string
      }
    }
    dropCaps?: boolean
    [key: string]: any // eslint-disable-line @typescript-eslint/no-explicit-any
  }
  websked: {}
  tansa: {}
  route: {}
  featureFlag: {}
}

export interface IActionSetRelatedContent {
  type: actionTypes.ACTION_SET_RELATED_CONTENT
  payload: { data: object; isDenormalizing: boolean; hasError: boolean }
}

export interface IActionDenormalizeRelatedContent {
  type: actionTypes.ACTION_DENORMALIZE_RELATED_CONTENT
}

export type ActionTypes =
  | { type: actionTypes.ACTION_ADD_RELATED_ITEM; payload: { type: string } }
  | {
      type: actionTypes.ACTION_REMOVE_RELATED_ITEM
      payload: { id: string; type: string }
    }
  | IActionSetRelatedContent
  | IActionDenormalizeRelatedContent

export interface IDraftRelatedContent {
  data: {
    image?: ImmutableMap<string, any>[] // eslint-disable-line @typescript-eslint/no-explicit-any
    story?: ImmutableMap<string, any>[] // eslint-disable-line @typescript-eslint/no-explicit-any
    video?: ImmutableMap<string, any>[] // eslint-disable-line @typescript-eslint/no-explicit-any
    gallery?: ImmutableMap<string, any>[] // eslint-disable-line @typescript-eslint/no-explicit-any
  }
  isDenormalizing: boolean
  hasError: boolean
}
